import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const Favorite: BleskIcon = forwardRef(function Favorite(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.04527 12.2814L7.8315 11.07C7.53285 10.7719 7.42612 10.3317 7.55507 9.92993C7.68402 9.52815 8.02696 9.23231 8.44331 9.1637L10.0458 8.89964L11.0073 7.09584C11.2028 6.7291 11.5845 6.5 12.0001 6.5C12.4157 6.5 12.7974 6.7291 12.9929 7.09584L13.9544 8.89964L15.5569 9.1637C15.9732 9.23231 16.3162 9.52815 16.4451 9.92993C16.5741 10.3317 16.4673 10.7719 16.1687 11.07L14.9549 12.2814L15.2465 14.2042C15.3092 14.6175 15.1375 15.0315 14.8008 15.2792C14.464 15.5269 14.0176 15.5674 13.6418 15.3844L12.0001 14.5851L10.3584 15.3844C9.98257 15.5674 9.53622 15.5269 9.19943 15.2792C8.86264 15.0315 8.69097 14.6175 8.75365 14.2042L9.04527 12.2814Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 19H14.5L12.6897 20.7241C12.3035 21.092 11.6965 21.092 11.3103 20.7241L9.5 19.0001L6 19C4.34315 19 3 17.6569 3 16V6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V16C21 17.6569 19.6569 19 18 19Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
